const dashboard = {
  "dashboard-new-number-title": "データ数",
  "dashboard-new-demography-title": "デモグラフィック",
  "dashboard-new-trend-title": "トレンド",
  "dashboard-new-kpi-title": "コーザルKPI",

  "dashboard-new-asset-title": "変数バランス",

  "dashboard-new-asset-balance-title1": "エントリー数",
  "dashboard-new-asset-balance-title2": "エントリー数",

  "dashboard-new-asset-balance-attr1": "共変量/交絡因子",
  "dashboard-new-asset-balance-attr2": "処置変数",
  "dashboard-new-asset-balance-attr3": "アウトカム変数",

  "dashboard-new-asset-ranking-title1": "共変量/交絡因子",
  "dashboard-new-asset-ranking-title2": "処置変数",

  "dashboard-new-asset-heatmap-legend1": "データが多い（解析が十分可能）",
  "dashboard-new-asset-heatmap-legend2": "データがある（解析可能）",
  "dashboard-new-asset-heatmap-legend3": "データが少ない（解析を推奨しない）",

  "dashboard-new-prior-title": "コーザルアセット",

  "dashboard-demographics-label": "デモグラフィック",
  "dashboard-demographics-ratio-label": "構成比率",
  "dashboard-demographics-condition-level-label": "デモグラフィック",

  "dashboard-kpi-title": "主要KPIトレンド",
  "dashboard-kpi-popover-button": "設定",
  "dashboard-kpi-reorder-reset-button": "リセット",
  "dashboard-kpi-reorder-save-button": "保存",
  "dashboard-kpi-reorder-max-message": "KPI項目の最大数は8です。",
  "dashboard-kpi-reorder-min-message": "KPI項目の最小数は1です。",

  "demographics-genders-label": "性別",
  "demographics-ages-label": "年代",
};

export default dashboard;
